module.exports = __webpack_public_path__ + "static/media/menu-communaute.f9fb0e40.svg";